import React, { useEffect, useState } from "react";
import { Box, Button, Divider, IconButton, Modal, Typography, CircularProgress, } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import { useDeleteUserPerfil } from "../../../hooks/AdministracionUsuarios/adminPerfiles/deleteUserPerfil";

interface PerfilEliminar {
    id: number;
    nombre: string;
    descripcion: string;
}

interface DeleteUserPerfilProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => Promise<void> | void;
    perfil: PerfilEliminar | null;
}

const DeleteUserPerfil: React.FC<DeleteUserPerfilProps> = ({
    open,
    onClose,
    onSuccess,
    perfil,
}) => {

    const {
        eliminarPerfil,
        loading,
    } = useDeleteUserPerfil();

    const [nombre, setNombre] = useState("");
    const [descripcion, setDescripcion] = useState("");

    useEffect(() => {

        if (!open || !perfil) {
            return;
        }

        setNombre(perfil.nombre);
        setDescripcion(perfil.descripcion);

    }, [open, perfil]);

    const limpiarFormulario = () => {

        setNombre("");
        setDescripcion("");

    };

    const cerrarModal = () => {

        limpiarFormulario();

        onClose();

    };

    const eliminar = async () => {

        if (!perfil) {
            return;
        }

        const ok = await eliminarPerfil(perfil.id);

        if (ok) {

            await onSuccess?.();

            cerrarModal();

        }

    };

    return (

        <Modal
            open={open}
            onClose={cerrarModal}
        >

            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 520,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                }}
            >

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                    >
                        Eliminar Perfil
                    </Typography>

                    <IconButton onClick={cerrarModal}>
                        <CloseIcon />
                    </IconButton>

                </Box>

                <Divider sx={{ mb: 3 }} />

                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                >

                    <WarningAmberRoundedIcon
                        color="warning"
                        sx={{
                            fontSize: 70,
                        }}
                    />

                    <Typography
                        variant="h6"
                        fontWeight={600}
                        align="center"
                    >
                        ¿Deseas eliminar este perfil?
                    </Typography>

                    <Box
                        sx={{
                            width: "100%",
                            bgcolor: "#f5f5f5",
                            borderRadius: 2,
                            p: 2,
                            mt: 1,
                        }}
                    >

                        <Typography variant="body2">
                            <strong>Nombre:</strong> {nombre}
                        </Typography>

                        <Typography
                            variant="body2"
                            mt={1}
                        >
                            <strong>Descripción:</strong> {descripcion}
                        </Typography>

                    </Box>

                </Box>

                <Divider sx={{ my: 3 }} />

                <Box
                    display="flex"
                    justifyContent="flex-end"
                    gap={2}
                >

                    <Button
                        variant="contained"
                        onClick={cerrarModal}
                        sx={{
                            bgcolor: "#F70083",
                            color: "#fff",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": {
                                bgcolor: "#D60072",
                            },
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={eliminar}
                        disabled={loading}
                        sx={{
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                        }}
                    >
                        {loading ? (
                            <>
                                <CircularProgress
                                    size={18}
                                    color="inherit"
                                    sx={{ mr: 1 }}
                                />
                                Eliminando...
                            </>
                        ) : (
                            "Eliminar Perfil"
                        )}
                    </Button>

                </Box>

            </Box>

        </Modal>

    );

};

export default DeleteUserPerfil;